import { FormikProvider, useFormik } from 'formik'

import {
  UPDATE_EMAIL_KEY,
  updateUserEmail,
  VERIFY_PASSWORD_KEY,
  verifyPassword,
} from '@/actions/authActions'
import { selectErrorsForKeys } from '@/reducers/fetch'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'

import { getFieldName, makeReqEmailSchema, makeReqStringSchema } from '@/base'
import { Alert, Button, Dialog, Form, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const ChangeEmailDialog = () => {
  const dispatch = useAppDispatch()

  const errors = useReselector(selectErrorsForKeys, [
    VERIFY_PASSWORD_KEY,
    UPDATE_EMAIL_KEY,
  ])

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },

    onSubmit: async ({ email, password }) => {
      const passwordResponse = await verifyPassword({ password })(dispatch)
      const emailResponse = await updateUserEmail({ newEmail: email })(dispatch)

      if (!passwordResponse) {
        return
      }

      if (emailResponse) {
        close()
      }
    },
  })

  return (
    <Dialog>
      <Dialog.Trigger asChild>
        <Button variant="link" size="sm">
          <Text variant={TypographyStyles.LABEL_SM}>Change email address</Text>
        </Button>
      </Dialog.Trigger>

      <Dialog.Content size="sm" onDismiss={() => null}>
        <Dialog.Title>Change Your Email Address</Dialog.Title>

        <Dialog.Description>
          To change your email address, enter your password and your new email
          address.
        </Dialog.Description>

        <FormikProvider value={formik}>
          {Boolean(errors.length) && (
            <Alert variant="error">{errors[0].message}</Alert>
          )}

          <Form.Input
            name={getFieldName<typeof formik.values>('password')}
            label="Password"
            type="password"
            schema={makeReqStringSchema()}
          />

          <Form.Input
            name={getFieldName<typeof formik.values>('email')}
            label="New Email"
            type="email"
            schema={makeReqEmailSchema()}
          />

          <Dialog.Footer>
            <Dialog.Close asChild>
              <Button variant="ghost">Cancel</Button>
            </Dialog.Close>

            <Button onClick={formik.submitForm}>Update Email</Button>
          </Dialog.Footer>
        </FormikProvider>
      </Dialog.Content>
    </Dialog>
  )
}
